import { Box, Button, Stack } from "@mui/material";
import React, { useState } from "react";
import ChangePassword from "./changePassword";
import Notification from "./notification";
import SupportFeedback from "./support-feedback";
import Subscriptions from "./subscriptions";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import RoleManagementTable from "./role-management";
import WalletContent from "./wallet";

const btn = {
  fontFamily: "Outfit",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "23.79px",
  padding: "6px 12px",
  borderRadius: "12px",
  width: 160,
  height: "40px",
  "&: hover": {
    background: "#284cb1",
    color: "#fff",
    opacity: "35%",
  },
};

const ProfileControls = () => {
  const [active, setActive] = useState("password");
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xs");
  const handleMode = (value: string) => setActive(value);
  return (
    <Box sx={{ my: 4, width: "100%" }}>
      <Box sx={{ display: "flex", overflowX: "auto" }}>
        <Stack
          direction={"row"}
          sx={{
            background: theme.palette.lightBlue.main,
            padding: 1,
            borderRadius: "20px",
            gap: 1,
          }}
        >
          <Button
            onClick={() => handleMode("password")}
            sx={{
              ...btn,
              background: active === "password" ? "#2F66F4" : "",
              color: active === "password" ? "#fff" : "#2F66F4",
            }}
          >
            Change Password
          </Button>
          <Button
            onClick={() => handleMode("notification")}
            sx={{
              ...btn,
              background: active === "notification" ? "#2F66F4" : "",
              color: active === "notification" ? "#fff" : "#2F66F4",
            }}
          >
            Notification
          </Button>
          <Button
            onClick={() => handleMode("feedback")}
            sx={{
              ...btn,
              background: active === "feedback" ? "#2F66F4" : "",
              color: active === "feedback" ? "#fff" : "#2F66F4",
            }}
          >
            Support and Help
          </Button>
          <Button
            onClick={() => handleMode("wallet")}
            sx={{
              ...btn,
              background: active === "wallet" ? "#2F66F4" : "",
              color: active === "wallet" ? "#fff" : "#2F66F4",
            }}
          >
            Wallet
          </Button>
          {/* <Button
            onClick={() => handleMode("role-management")}
            sx={{
              ...btn,
              background: active === "role-management" ? "#2F66F4" : "",
              color: active === "role-management" ? "#fff" : "#2F66F4",
            }}
          >
            Role Management
          </Button> */}
        </Stack>
      </Box>
      <Box>
        {active === "password" && <ChangePassword />}
        {active === "notification" && <Notification />}
        {active === "feedback" && <SupportFeedback />}
        {active === "wallet" && <WalletContent />}

        {/* {active === "role-management" && <RoleManagementTable loading={true} />} */}
      </Box>
    </Box>
  );
};

export default ProfileControls;
